<template>
  <Modal @close="closeModal" closeMessage="Hide Details">
    <template v-slot:body>
      <v-card
    class="mx-auto flex-Card"
    height="100%"
    max-width="100%"
    rounded
    elevation="0"
  >
  <div>
    <div style="position:relative">
      <v-img
        class="white--text align-end gradient"
        aspect-ratio="1.7778"

        @load="showTitle = false"
        @error="showTitle = true"
        width="100%"
      :src="Event.EventPhoto ? `https://voxchurch.org/GetImage.ashx?id=${Event.EventPhoto.Id}` : ''"
      >

      </v-img>
      <div class="campusBox">{{formatDate(Event.EventNextStartDate.StartDateTime)}}</div>
    </div>
  <v-card-title class="titleFont">{{Event.EventName}}</v-card-title>
    <v-card-subtitle class="pb-0" style="display:flex; flex-direction:row; flex-wrap:nowrap; justify-content:space-between; align-items:; flex-shirnk:1">

        <div style="flex-shrink:1;">
          {{ formatDate(Event.EventNextStartDate.StartDateTime) }} at {{ formatTime(Event.EventNextStartDate.StartDateTime) }}
          <div>{{ Event.OccurrenceLocation }}</div>
          <div v-if="calculateSpotsRemaining.LimitedSpots && calculateSpotsRemaining.SpotsRemaining > 0 ">Spots Remaining: {{ calculateSpotsRemaining.SpotsRemaining }}</div><br/>
        </div>
        <!-- <div style="flex-grow:1; align-content:flex-end;  break-inside: avoid;" class="text-right">
            {{Event.CampusName}}
        </div> -->

    </v-card-subtitle>
    </div>
  <div class="flex-Card">
    <v-card-text class="text--primary">
      <div>
         <div class="font-weight-bold">Description:</div>
        <div v-html="Event.EventDescription"></div>
        <div class="font-weight-bold">Upcoming Dates:</div>
        <ul>
          <li v-for="date in Event.UpcomingDates" :key="date.StartDateTime.toString()">{{formatDate(date.StartDateTime) }} at {{ formatTime(date.StartDateTime) }} to {{formatDate(date.EndDateTime) != formatDate(date.StartDateTime) ? `${formatDate(date.EndDateTime)} at` : ''}} {{ formatTime(date.EndDateTime) }}</li>
        </ul>
        <div v-if="Event.RegistrationInformation.length > 0">
            <div class="font-weight-bold">Registration Information:</div>
            <ul>
              <li v-for="registration in Event.RegistrationInformation" :key="registration.RegistrationInstanceId">
                <span>{{registration.RegistrationPublicName}} - Register Between {{formatDate(registration.RegistrationStartDate) }} and {{formatDate(registration.RegistrationEndDate) }}</span><br />
                <span vif="!registrationSpotsRemaining(registration).LimitedSpots || registrationSpotsRemaining(registration).SpotsRemaining > 0">
                  <a :href="registration.RegistrationPublicSlug != '' ? `https://voxchurch.org/registration/${registration.RegistrationPublicSlug}` : `https://voxchurch.org/registration?RegistrationInstanceId=${registration.RegistrationInstanceId}`" class="btn btn-primary" style="color:white;">Register</a>
                </span>
              </li>
            </ul>
         </div>
      </div>
    </v-card-text>
   </div>
  </v-card>
    </template>
       
  </Modal>


  
</template>

<script>
import Eventcard from './EventCard';
import Modal from './Modal';

export default {
  components: {
    Eventcard,
    Modal
  },
  props: {
    Event: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showTitle: false,
  }),
  methods: {
    closeModal() {
      this.$emit('CloseModal');
    },
    formatDate(dateItem) {
      const options = {
        year: 'numeric', month: 'long', day: 'numeric',
      };

      const newDate = new Date(dateItem);
      return newDate.toLocaleDateString('en-US', options);
    },
    formatTime(dateItem) {
      const options = {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      };
      const newDate = new Date(dateItem);
      return newDate.toLocaleTimeString('en-US', options);
    },
    registrationSpotsRemaining(registration) {
      let SpotsRemaining = null;
      let LimitedSpots = false;

      SpotsRemaining = registration.RegistrationMaxAttendees - registration.RegistrationTotalRegistrants;
      LimitedSpots = registration.RegistrationMaxAttendees > 0 ? registration.RegistrationMaxAttendees : false;

      return {
        LimitedSpots,
        SpotsRemaining,
      };
    },
  },
  computed: {
    calculateSpotsRemaining() {
      let SpotsRemaining = null;
      let LimitedSpots = false;

      if (this.Event.RegistrationInformation[0]) {
        SpotsRemaining = this.Event.RegistrationInformation[0].RegistrationMaxAttendees - this.Event.RegistrationInformation[0].RegistrationTotalRegistrants;
        LimitedSpots = this.Event.RegistrationInformation[0].RegistrationMaxAttendees > 0 ? this.Event.RegistrationInformation[0].RegistrationMaxAttendees : false;
      }
      return {
        LimitedSpots,
        SpotsRemaining,
      };
    },
  },
};
</script>

<style scoped>

.gradient {
   background-color:black;
 }
 .titleFont {
   font-size:clamp(1.5rem, 2vw, 3rem);
   /* padding-left:0; */
    white-space: break-spaces;
    word-break: inherit;
 }
 .gradient {
   background: rgb(255,255,255);
   background: linear-gradient(0deg, rgba(255,255,255,.9) 46%, rgba(52, 174, 183, 1)90%);
 }

 .campusBox {
    position:absolute;
    right:0;
    bottom:0;
    background-color:rgba(0,0,0,.75);
    color:white;
    padding:5px 10px 5px 20px;

 }
</style>
